import {useState, forwardRef} from "react";
import "./contact.css";
import { motion } from "framer-motion";
import Swal from 'sweetalert2';
import { useLanguage } from "../../context/LanguageContext";

const variants = {
    initial: {
        y: 50,
        opacity: 0,
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.5,
            staggerChildren: 0.1,
        },
    },
};

const Contact = forwardRef<HTMLElement>((props, ref) => {
    const [copied, setCopied] = useState(false);
    const { t } = useLanguage();
    const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || "contacto@matiasnorambuena.dev";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(contactEmail);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);

        Swal.fire({
            title: t("contact.copied"),
            text: t("contact.copiedDesc"),
            icon: "success",
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            background: "#081b29",
            color: "#ededed",
            iconColor: "#00abf0"
        });
    };

    return (
        <motion.section
            className="contact"
            id="Contact"
            ref={ref}
            variants={variants}
            initial="initial"
            whileInView="animate"
        >
            <motion.div className="textContainer" variants={variants}>
                <motion.h1 variants={variants} className="getin">{t('contact.getIn')}</motion.h1>
                <h1>{t('contact.touch')}</h1>
                <p className="contact-subtitle">{t('contact.subtitle')}</p>
            </motion.div>
            <div className="formContainer d-flex align-items-center justify-content-center">
                <motion.div
                    className="contact-card d-flex flex-column align-items-center justify-content-center"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                >
                    <div className="icon-wrapper">
                        <i className='bx bx-envelope'></i>
                     </div>
                    <h2>{t('contact.emailTitle')}</h2>
                    <a href={`mailto:${contactEmail}`} className="email-link">
                        {contactEmail}
                    </a>
                    <button className="copy-btn" onClick={copyToClipboard}>
                        <i className='bx bx-copy'></i>
                        {copied ? t('contact.copied') : t('contact.copy')}
                    </button>
                </motion.div>
            </div>
        </motion.section>
    );
});

export default Contact;